__turbopack_context__.v({
  "spinner": "Spinner-module-scss-module__BRC7pW__spinner",
});
